import { AfterViewInit, Component, ElementRef, EventEmitter, Injector, Input, Output, ViewChild } from '@angular/core';
import { AbstractComponent, AttendanceCopilotActionsService } from 'lib-trend-core';
import { map, Observable } from 'rxjs';

export type CopilotDrawerPane = 'insight' | 'actions';

/**
 * The drawer over the Copilot chat: the insight or the Actions in full, one pane at a time,
 * behind the summary strip (SPEC-2026-10-copilot-attendance-actions, prototype D). It only
 * switches panes and closes; each pane keeps its own state service.
 */
@Component({
  selector: 'attendance-copilot-drawer',
  templateUrl: './attendance-copilot-drawer.component.html',
  styleUrls: ['./attendance-copilot-drawer.component.scss'],
  standalone: false,
})
export class AttendanceCopilotDrawerComponent extends AbstractComponent implements AfterViewInit {
  @Input({ required: true }) pane!: CopilotDrawerPane;
  @Input() attendanceClosed = false;
  @Output() readonly paneChange = new EventEmitter<CopilotDrawerPane>();
  @Output() readonly closed = new EventEmitter<void>();

  @ViewChild('back') backButton?: ElementRef<HTMLButtonElement>;

  readonly pendingCount$: Observable<number> = this.actionsService
    .select()
    .pipe(map((state) => (state.view?.actions?.items ?? []).filter((item) => item.state === 'pending').length));

  constructor(
    injector: Injector,
    private readonly actionsService: AttendanceCopilotActionsService,
  ) {
    super(injector);
  }

  /** The keyboard focus moves into the drawer when it opens (RNF-09); a pane switch keeps the same drawer. */
  ngAfterViewInit(): void {
    this.backButton?.nativeElement.focus();
  }

  titleKey(): string {
    return 'attendance.copilot.drawer.' + (this.pane === 'actions' ? 'actionsTitle' : 'insightTitle');
  }
}
